module.exports = __webpack_public_path__ + "static/media/dg3.b1546ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/events/dg3.jpg
// module id = 1202
// module chunks = 0